import { useNavigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { useCompany } from "./context/CompanyContext";
import { canAccessPath } from "../util/accessControl";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import PeopleIcon from "@mui/icons-material/People";
import GroupsIcon from "@mui/icons-material/Groups";
import PaymentsIcon from "@mui/icons-material/Payments";
import MapIcon from "@mui/icons-material/Map";

const BRAND = "#EE8253";

const NAV_ITEMS = [
  { label: "Vendas",           sub: "Indicadores gerais",    icon: TrendingUpIcon, path: "indicadoresvendas"     },
  { label: "Vend. Estratégica", sub: "Segmentação de clientes", icon: GroupsIcon,    path: "indicadoresestrategica" },
  { label: "Pagamentos",       sub: "Mix e métodos",         icon: PaymentsIcon,   path: "indicadorespagamentos"  },
  { label: "Mapa de Vendas",   sub: "Distribuição geográfica", icon: MapIcon,       path: "indicadoresmapa"       },
];

export default function IndicadoresNav() {
  const { slug, accessControl } = useCompany();
  const position = useSelector((state) => state.user.currentUser?.position);
  const nav = useNavigate();
  const { pathname } = useLocation();
  // Cards sem permissão no controle de acesso (2º nível) somem.
  const items = NAV_ITEMS.filter(({ path }) =>
    canAccessPath(accessControl, position, `/${slug}/${path}`),
  );

  return (
    <div style={{ display: "grid", gridTemplateColumns: `repeat(${items.length}, 1fr)`, gap: 12, marginBottom: 24 }}>
      {items.map(({ label, sub, icon: Icon, path }) => {
        const active = pathname.includes(path);
        return (
          <div
            key={path}
            onClick={() => nav(`/${slug}/${path}`)}
            style={{
              background: active ? `linear-gradient(135deg, ${BRAND}, #E8502A)` : "#fff",
              border: `1.5px solid ${active ? BRAND : "#E5E7EB"}`,
              borderRadius: 12,
              padding: "14px 18px",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              gap: 12,
              transition: "box-shadow 0.15s, transform 0.15s",
              boxShadow: active ? "0 4px 14px rgba(238,130,83,0.35)" : "0 1px 4px rgba(0,0,0,0.05)",
            }}
          >
            <div style={{
              width: 36,
              height: 36,
              borderRadius: 8,
              background: active ? "rgba(255,255,255,0.2)" : "#FEF3ED",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
            }}>
              <Icon style={{ fontSize: 20, color: active ? "#fff" : BRAND }} />
            </div>
            <div>
              <div style={{ fontSize: 13, fontWeight: 800, color: active ? "#fff" : "#111827", fontFamily: "Manrope", lineHeight: 1.2 }}>{label}</div>
              <div style={{ fontSize: 11, color: active ? "rgba(255,255,255,0.75)" : "#9CA3AF", fontFamily: "Manrope", marginTop: 2 }}>{sub}</div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
